<div class="rounded-small shadow-[0_4px_18px_0_rgba(0,0,0,0.17)] p-8" *transloco="let t; prefix: 'shared.requests-unauthorized.'+suffix">
    <div class="flex flex-col rfs:gap-7">
        <div class="flex justify-between">
            <div class="flex flex-col gap-2">
                <h2 class="text-black font-medium md:h2 md:leading-10 text-xl">{{t('create-login')}}</h2>
            </div>
            <div>
                <i class="icon-close hover:cursor-pointer" (click)="onClose()"></i>
            </div>
        </div>
        <div class="divider-line1 border-b-tone-05"></div>
        <div class="flex flex-col gap-3">
            <p class="text-gray-900">{{t('create-account')}}</p>
        </div>
        <img class="object-contain w-full h-[190px] md:h-[245px]" [src]="imgSrc"
            alt="erikceder document being stamped">
        <div class="flex pb-4 pt-2 flex-col gap-3">
            <a class="btn-primary text-center w-full" [localizedRouterLink]="['/register']">{{'shared.requests-unauthorized.button.create-account' | transloco}}</a>
            <span class="text-gray-900 flex justify-center">{{'shared.requests-unauthorized.already-registered' | transloco}} <a
                    class="text-primary font-medium ml-1 underline cursor-pointer"  (click)="navigateToLoginWithRedirect()"
                    >{{'shared.requests-unauthorized.login-here' | transloco}}</a></span>
        </div>
    </div>
</div>